import { Controller } from 'stimulus'
import Rails from '@rails/ujs'
import { useDebounce, useDispatch } from 'stimulus-use'

export default class extends Controller {
  static values = { searchId: Number, reportId: Number }
  static targets = [
    'createReportButton', 'selectBillCardsController',
    'filtersForm', 'orderByForm'
  ]

  connect() {
    useDispatch(this)
  }

  disableReportButtons(event) {
    this.setDisabilityOnReportButtons(true)
  }

  enableReportButtons(event) {
    this.setDisabilityOnReportButtons(false)
  }

  createOrUpdateReport() {
    if (this.areAllCreateReportButtonsEnabled()) {
      const reportData = this.getDataToCreateReport()
      const parametrizedReportData = $.param(reportData)

      if (this.searchIdValue) {
        this.updateReportSearch(parametrizedReportData)
      } else {
        this.createReport(parametrizedReportData)
      }
    } else {
      console.log('Missing to select at least one document')
    }
  }

  createReport(data) {
    Rails.ajax({
      type: 'POST',
      url: '/reports/policies',
      dataType: 'json',
      data: data,
      success: () => {
        this.dispatch(
          'reportCreated', { reportData: $.deparam(data) }
        )
      },
      error: (data) => {
        alert('Something went wrong')
      }
    })
  }

  updateReportSearch(data) {
    Rails.ajax({
      type: 'PUT',
      url: `/omni_searches/${this.searchIdValue}/reports/${this.reportIdValue}`,
      dataType: 'json',
      data: data,
      success: () => {
        this.dispatch(
          'reportUpdated', {
            reportData: $.deparam(data),
            reportId: this.reportIdValue
          }
        )
      },
      error: (data) => {
        alert('Something went wrong')
      }
    })
  }

  getDataToCreateReport() {
    const createData = this.getFilterFormInputsValue()

    Object.assign(createData.search_attributes,
      this.getIncludedExcludedEntitiesId(),
      this.getOrderByFormInputsValue().search_attributes)

    Object.assign(createData)

    return createData
  }

  getFilterFormInputsValue() {
    return $.deparam($(this.filtersFormTarget).serialize())
  }

  getIncludedExcludedEntitiesId() {
    const selectBillCardsController = this.getSelectBillCardsController()
    const checkboxesValues = []

    if (selectBillCardsController.areUnseenBillsSelected) {
      selectBillCardsController.checkboxesUnchecked().forEach((elem) => {
        checkboxesValues.push(elem.value)
      })

      return {
        excluded_ids: checkboxesValues,
        included_ids: []
      }
    } else {
      selectBillCardsController.checkboxesChecked().forEach((elem) => {
        checkboxesValues.push(elem.value)
      })

      return {
        excluded_ids: [],
        included_ids: checkboxesValues
      }
    }
  }

  getOrderByFormInputsValue() {
    return $.deparam($(this.orderByFormTarget).serialize())
  }

  areAllCreateReportButtonsEnabled() {
    const isAtLeastOneButtonDisabled = this.createReportButtonTargets.some((button) => { if (button.hasAttribute('disabled')) return true })
    return !isAtLeastOneButtonDisabled
  }

  refreshCreateReportButton() {
    const selectBillCardsController = this.getSelectBillCardsController()
    const billsSelectedAmount = selectBillCardsController.checkboxesCheckedCount()

    if (!Number.isFinite(billsSelectedAmount)) { this.setDisabilityOnReportButtons(true) } else { this.setDisabilityOnReportButtons(billsSelectedAmount <= 0) }
  }

  setDisabilityOnReportButtons(isDisabled) {
    const buttonDisabledClass = 'c-button--state-disabled'
    if (isDisabled) {
      this.createReportButtonTargets.forEach((button) => {
        button.setAttribute('disabled', 'disabled')
        button.classList.add(buttonDisabledClass)
      })
    } else {
      this.createReportButtonTargets.forEach((button) => {
        button.removeAttribute('disabled')
        button.classList.remove(buttonDisabledClass)
      })
    }
  }

  getSelectBillCardsController() {
    return this.selectBillCardsControllerTarget['select-bill-cards']
  }
}
